import { z } from "zod";
import { DATE_RANGE, OWNER, PROPERTY } from "./consts";

export const schema = z.object({
  [OWNER]: z.string().min(1, "This field is required"),
  [PROPERTY]: z.string().min(1, "This field is required"),
  [DATE_RANGE]: z.any().optional(),
});

export type formValues = z.infer<typeof schema>;
